<template>
	<!-- 支付页面 -->
	<div class="main">
		<div class="title">{{info.productName}}</div>
		<Steps :current="2" style="margin:20px auto; width:700px;padding-left:116px">
			<Step title="申请信息"></Step>
			<Step title="确认信息"></Step>
			<Step title="支付"></Step>
		</Steps>
		<div class="order">
			<div class="order-title">订单信息</div>
			<Table :columns="columns" border :data="orderData">
				<template slot-scope="{ row }" slot="productName">
					<b style="font-size:16px;">{{row.productName}}</b>
				</template>
				<template slot-scope="{ row }" slot="payPrice">
					<div class="price">
						<p>
							<span class="price-label">订单金额：</span>
							<span class="price-value">{{row.totalAmount}}元</span>
						</p>
					</div>
				</template>
			</Table>
		</div>
		<div class="center fz16" v-if="info.orderStatus=='UNPAID'">
			<template v-if="(info.productCode == 'PINGAN_PROPERTY_GROUP_ACCIDENT_INSURANCE' || info.productCode == 'PINGAN_EMPLOYER_LIABILITY') && info.totalAmount == 0">正在确认支付结果，请耐心等待。</template>
			<template v-else>当天24时前未完成支付订单，将自动关闭。</template>
		</div>
		<div class="center fz16" v-if="info.orderStatus&&info.orderStatus!='UNPAID'">支付状态：{{info.orderStatusDesc}}</div>
		<Row class="mt15" v-if="info.orderStatus=='UNPAID'&&info.totalAmount>0" >
			<Col span="12" offset="9">
				<p>
					<span class="form-label">支付方式：</span>
					<span class="form-value">
						<RadioGroup v-model="payType" @on-change="payTypeChange" >
							<Radio :label="item.key" :disabled="Boolean(info.payVoucherUrl)" v-for="(item, index) in payTypeList" :key="index">{{item.value}}</Radio>
						</RadioGroup>
					</span>
				</p>
				<!-- <Form ref="form">
					<FormItem label="支付方式：">
						
					</FormItem>
				</Form> -->
			</Col>
			<Col span="12" offset="9">
				<div class="pay" v-show="payType&&payType!=='PUBLIC_BANK'&&info.productCode=='GUOSHOU_EMPLOYER_LIABILITY'">
					<div class="code">
						<div id="qrcode" v-show="!loading"></div>
						<p>
						请使用
						<span v-if="payType==item.key" v-for="(item, index) in payTypeList" :key="index">{{item.value}}</span>
						扫码支付
						</p>
					</div>
				</div>
			</Col>
			<Col span="14" offset="5">
				<div v-if="payType=='PUBLIC_BANK'||payType=='THIRD_PARTY_PUBLIC_BANK'" class="publicPay mt10">
					<p v-if="info.productCode!='PINGAN_EMPLOYER_LIABILITY'" class="note">选择对公支付的会员，请及时付款至以下指定账户，平台会根据您已提交的信息生成各类投保订单。<span v-if="(info.productCode=='PINGAN_GROUP_ACCIDENT_INSURANCE_A'||info.productCode=='PINGAN_GROUP_ACCIDENT_INSURANCE_B')">同时对公支付需要线下审核，预计等待2-3个工作日</span></p>
					<div class="form">
						<p class="red" style="text-align:center;" v-if="info.productCode=='PINGAN_EMPLOYER_LIABILITY'">
							请在转账的附言或备注中填写通知单号
						</p>
						<!-- 大地对公支付信息 人资 meng-->
						<template v-if="payType=='THIRD_PARTY_PUBLIC_BANK'&&(info.productCode=='CCIC_EMPLOYER_LIABILITY_M1'||info.productCode=='CCIC_EMPLOYER_LIABILITY_M2')">
							<p>
								<span class="form-label">名称：</span>
								<span class="form-value">中国大地财产保险股份有限公司青岛分公司</span>
							</p>
							<p>
								<span class="form-label">开户行：</span>
								<span class="form-value">中国工商银行青岛市南第二支行</span>
							</p>
							<p>
								<span class="form-label">账号：</span>
								<span class="form-value">3803 0349 1910 0012 157</span>
							</p>
						</template>
						<p class="red" style="display: flex; align-items: center;">
							<span class="form-label">注意：</span>
							<span class="form-value">1、对公支付，在付款后，请上传支付凭证</span>
						</p>
						<p class="red" style="display: flex;">
							<span class="form-label"></span>
							<span class="form-value">2、确认收到款项后，会向手机号{{info.applicantList[0].contactPhone||''}}发送短信</span>
						</p>
						<p class="red" style="display: flex;">
							<span class="form-label"></span>
							<span class="form-value" style="width:400px" v-if="info.productCode=='PINGAN_EMPLOYER_LIABILITY'">3、对公付款时请备注以下通知单号，且请勿附加其他备注内容，否则会影响承保</span>
							<span class="form-value" v-else>3、对公付款时请备注以下信息，否则会影响承保</span>
						</p>
						<p class="red" v-if="info.productCode=='PINGAN_EMPLOYER_LIABILITY'&&info.extraInfo">
							<span class="form-label">通知单号：</span>
							<span class="form-value">
								{{info.extraInfo.noticeNo}}
								<Button
								type="primary"
								size="small"
								@click="copy"
								class="copyBtn"
								:data-clipboard-text="`${info.extraInfo.noticeNo}`"
								>复制</Button>
							</span>
						</p>
						<p class="mt15">
							<span class="form-label"></span>
							<span class="form-value">
								{{info.applicantName}}+{{info.productName}}
								<Button
								type="primary"
								size="small"
								@click="copy"
								class="copyBtn"
								:data-clipboard-text="`${info.applicantName}+${info.productName}`"
								>复制</Button>
							</span>
						</p>
						<p class="mt15">
							<span class="form-label"></span>
							<UploadFile @on-success="handleSuccess" type="select">
								<Button type="primary">上传支付凭证</Button>
							</UploadFile> 
							<a @click="openOriginFile(info.payVoucherUrl)" v-if="info.payVoucherUrl">查看文件</a>
						</p>
						<p class="mt15">
							<span class="form-label"></span>
							<Button type="success" v-if="info.productCode=='PINGAN_PROPERTY_GROUP_ACCIDENT_INSURANCE'" @click="confirmUploadPingAn">提交并返回列表</Button>
							<Button type="success" v-else @click="confirmUpload" :disabled="!Boolean(info.payVoucherUrl)">提交凭证</Button>
						</p>
					</div>
				</div>
			</Col>
			<Col span="12" offset="9">
				<div v-if="payType=='THIRD_PARTY_ONLINE'">
					<p class="mt20" v-if="info.productCode=='PINGAN_EMPLOYER_LIABILITY'">如您已支付完成，但此页面仍展示支付按钮，请刷新此页面。</p>
					<!-- 众安雇主 -->
					<p class="mt20" v-if="info.productCode=='ZHONGAN_EMPLOYER_LIABILITY'">
						<Button type="primary" :loading="payLoading" @click="zhonganPaylick">立即支付</Button>
					</p>
				</div>
			</Col>
		</Row>
		<!--众安form表单支付-->
        <form :action="payUrl" method="post" ref="zaform" accept-charset="UTF-8" target="myWin" v-show="false">
            <span v-for="(val, key) in zhonganpayForm" :key="key">
                <input type="text" :name="key" :value="val" />
            </span>
        </form>
	</div>
	</template>
	<script>
	import QRCode from "qrcodejs2";
	import Clipboard from "clipboard";
	import UploadFile from '@/components/common/UploadFileImg'
	import track from "@/mixin/track";
	export default {
		components:{UploadFile},
		mixins:[track],
		data() {
			return {
				columns: [
					{
						title: "产品名称",
						key: "productName",
						slot: "productName"
					},
					{
						title: "订单号",
						key: "orderNo"
					},
					{
						title: "订单创建时间",
						key: "createTime",
						width: 200
					},
					{
						title: "支付",
						slot: "payPrice",
						width: 300
					}
				],
				orderData: [],
				info: {},
				clock: undefined,
				flag: true,
				use: true,
				payType: "",
				orderNo:this.$route.query.orderNo,
				qrcode:null,
				loading:false,
				payTypeList:[],
				modalLoading:false,
				form:{
					isApplicantPay:'0'
				},
				ruleValidate: {
                    payerName: [
                        { required: true, message: '付款人名称不能为空', trigger: 'blur' }
                    ],
                    payerIdCard: [
                        { required: true, message: '付款人身份证号码不能为空', trigger: 'blur' },
						{message:'格式错误', trigger:'blur', pattern: this.rules.idcard }
                    ],
					reason: [
                        { required: true, message: '代付原因不能为空', trigger: 'blur' }
                    ],
					relationshipToApplicant: [
                        { required: true, message: '付款人与投保企业关系不能为空', trigger: 'blur' }
                    ]
                },
				payUrl:'',
                payParams: {
                    requestDoc:""
                },
				param:{},
				zhonganpayForm:{},
				isLock:false,
				newPayObj:{},
				payLoading:false
			};
		},
		created() {
			this.getOrderInfo();
		},
		mounted () {
			// 回溯 开始录制
			this.$nextTick(this.startRecord);
			// 平安财险
			if(this.$route.query.productCode=='PINGAN_PROPERTY_GROUP_ACCIDENT_INSURANCE' || this.$route.query.productCode=='PINGAN_EMPLOYER_LIABILITY'){
				this.checkStatus();
			}
		},
		beforeRouteLeave (to, from, next) {
			this.clearCheckStatus();
			this.$nextTick(()=>{
				next();
			})
		},
		methods: {
			async getPayInfo(){
				await this.$axios.post('/broker/dict/item/list.json',{
					bizId:"SERVICE_PLATFORM",
                    companyId:"10095",
                    dictCode:"agent_code",
					productCode: this.info.productCode,
					key: this.info.applicantList[0].subjectCode
				}).then(res=>{
					this.newPayObj = res&&res.length>0?res[0]:{};
				});
			},
			zhonganPaylick(){ // 众安收银台支付
				this.$Modal.confirm({
                    title: '提示',
					render: (h) => {
						return h('div', [
							h('p',{},"即将跳转至第三方平台支付，是否确定跳转？"),
							h('p',[
								h('Icon',{
									props: {
										type:'ios-alert-outline'
									},
								}),
								h('span',{
									style: {
										color: "red",
										marginLeft:'10px'
									}
								},"支付完成后您可在【用户中心】查看保单")
							])
						])
					},
                    onOk: () => {
						this.payLoading = true;
						this.$axios.post('/broker/order/payUrl',{
							orderNo:this.orderNo,
							paymentSource: this.payType,
						}).then(async res=>{
							// 回溯 停止录制
							await this.stopRecord({
								policy_id: this.info.endorseNo?this.info.endorseNo:this.info.applicationNo
							});
							let data = JSON.parse(res);
							this.payLoading = false;
							this.payUrl = data.payUrl;
							this.zhonganpayForm = data.param;
							this.$nextTick(() => {
								this.$refs.zaform.submit();
							})
							window.open('','myWin');
						}).catch(err=>{
							this.payLoading = false;
						})
                    },
                    onCancel: () => {
                    }
                });
            },
			// 获取付款方式
			async getPayType(){
				await this.$axios.post('/broker/product/paymentSourceOptionalList',{
					productCode:this.info.productCode
				}).then(res=>{
					if(this.info.productCode=='SUNSHINE_EMPLOYER_LIABILITY'&&!this.info.endorseNo){ // 阳光雇主投保单不展示对公支付
						let data = res.filter(item=>item.key=='THIRD_PARTY_ONLINE');
						this.payTypeList=data;
					} else {
						this.payTypeList=res;
					}
				});	
			},
			// 获取订单信息
			getOrderInfo() {
				this.$axios.post('/broker/order/detail',{
					orderNo:this.orderNo
				}).then(res=>{
					this.info = res;
					this.info.applicantName=(res.applicantList&&res.applicantList.length>0?res.applicantList[0]:{}).subjectName
					this.orderData=[res];
					this.getPayType();
					if(this.info.orderStatus=='UNPAID'){
						// 待支付
						if(res.insuranceApplicationId){
							this.getPolicyInfo(res.insuranceApplicationId,'application')
						}else{
							this.getPolicyInfo(res.insurancePolicyId,'policy')
						}
					}
					this.payType = 'THIRD_PARTY_PUBLIC_BANK';
				});
			},
			// 获取投保单信息
			getPolicyInfo(id,type){
				let url=type=='application'?'/broker/insurance/application/detail':'/broker/insurance/policy/detail'
				this.$axios.post(url,{
					applicationId:id,
					insurancePolicyId:id
				}).then(res=>{
					this.info.phone=res.applicantList&&res.applicantList.length>0?res.applicantList[0].contactPhone:''
				});
			},
			// 获取二维码url
			getQrCodeUrl(){
				return this.$axios.post('/broker/order/payUrl',{
					orderNo:this.orderNo,
					paymentSource:this.payType
				})
			},
			// 获取二维码
			async getQrCode() {
				let payItem=this.payTypeList.find(item=>{
					return item.key==this.payType
				})
				if(payItem&&!payItem.payUrl){
					payItem.payUrl=await this.getQrCodeUrl()
				}
				if(!this.qrcode){
					this.qrcode = new QRCode("qrcode", {
						width: 200,
						height: 200, // 高度
						text: payItem.payUrl // 二维码内容
					});
				}else{
					this.qrcode.makeCode(payItem.payUrl)
				}
				this.checkStatus();
			},
			/*检查支付状态*/
			checkStatus() {
				this.clock = setInterval(() => {
					if (this.flag) {
						this.flag = false;
						this.$axios.post('/broker/order/detail',{
							orderNo:this.orderNo
						}).then(res=>{
							if(res.orderStatus=='PAID'){
								clearInterval(this.clock);
								this.$router.push({
									path:`/my/orderDetail/${this.orderNo}`
								});
							}
							this.flag = true;
						}).catch(res=>{
							this.flag = true;
						})
					}
				}, 3000);
			},
			// 清除循环
			clearCheckStatus() {
				clearInterval(this.clock);
			},
			// 切换支付方式
			payTypeChange() {
				this.clearCheckStatus();
				if (this.payType !== "PUBLIC_BANK"&&this.payType !== "THIRD_PARTY"&&this.payType!=='THIRD_PARTY_PUBLIC_BANK'&&this.payType!=='THIRD_PARTY_ONLINE') {
					this.getQrCode();
				}
			},
			// 复制
			copy() {
				let clipboard = new Clipboard(".copyBtn");
				clipboard.on("success", e => {
					this.toast("复制成功"); // 释放内存
					clipboard.destroy();
				});
				clipboard.on("error", e => {
					// 不支持复制
					this.alert("该浏览器不支持自动复制"); // 释放内存
					clipboard.destroy();
				});
			},
			// 上传成功payType
			handleSuccess(val){
				this.$set(this.info,'payVoucherUrl',val.url)
			},
			async confirmUploadPingAn(){
				if(!this.info.payVoucherUrl){
					// 回溯 停止录制
					await this.stopRecord({
						policy_id: this.info.endorseNo?this.info.endorseNo:this.info.applicationNo
					});
					window.location.href = '/haierProduct.html#/my/customizedCCIC/order';
					return
				}
				this.confirm('确定提交已上传凭证？',()=>{
					this.$axios.post('/broker/attachment/uploadAttachmentFile.json.all',{
						bizId: this.info.bizId,
						productCode: this.info.productCode,
						applicationId: this.info.insuranceApplicationId,
						orderId:this.info.id,
						fileList: [{
							fileUrl:this.info.payVoucherUrl,
							fileType:'RECEIPT_VOUCHER'
						}]
					}).then(async res=>{
						if(res.code==10000000){
							// 回溯 停止录制
							await this.stopRecord({
								policy_id: this.info.endorseNo?this.info.endorseNo:this.info.applicationNo
							});
							window.location.href = '/haierProduct.html#/my/customizedCCIC/order';
						}
					});
				})
			},
			confirmUpload(){
				this.confirm('确定提交已上传凭证？',()=>{
					this.$axios.post('/broker/order/upload/payVoucher.all',{
						orderNo:this.orderNo,
						payVoucherUrl:this.info.payVoucherUrl,
						paymentSource:this.payType
					}).then(async res=>{
						if(res.code==10000000){
							// 回溯 停止录制
							await this.stopRecord({
								policy_id: this.info.endorseNo?this.info.endorseNo:this.info.applicationNo
							});
							this.$router.push({
								path:`/pay-success/${this.orderNo}`
							});
							window.location.href=`/common.html#/paySuccessCCIC/${this.orderNo}?phone=${res}`
						}
					});
				})
			}
		}
	};
	</script>
	<style scoped lang="less">
	.main {
		padding: 20px 30px;
		margin-top:95px;
		min-height:calc(100vh - 420px)
	}
	.order-title {
		// font-size: 14px;
		margin-bottom: 10px;
	}
	.center {
		font-size: 25px;
		font-weight: bold;
		margin-top: 15px;
		color: #ff6600;
	}
	.pay {
		margin-top: 10px;
		display: flex;
		justify-content: center;
		text-align: center;
		width: 200px;
		margin-left: 45px;
	}
	.fz16{
		font-size: 1.142857em;
	}
	.code > p {
		margin-top: 15px;
	}
	.price {
		font-size: 1.142857em;
		&-label {
			width: 7em;
			display: inline-block;
			line-height: 2;
			text-align: right;
			font-size: 1.142857em;
			&.small{
				width: 92px;
			}
		}
		&-value {
			color: red;
			font-size: 1.142857em;
			&.disabled{
				color: #999;
				text-decoration: line-through;
			}
		}
	}
	.form {
		margin-top: 10px;
		// font-size: 14px;
		&-label {
			width: 7em;
			display: inline-block;
			line-height: 2;
			text-align: right;
		}
		.red {
			color: red;
		}
	}
	.publicPay {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
		.note {
			// font-size: 12px;
		}
	}
	.cModel{
		width:100%;
		color: rgba(16, 16, 16, 1);
		// font-size: 14px;
		text-align: center;
	}
	</style>


// WEBPACK FOOTER //
// src/pages/common/components/pay/indexDadi.vue